import { CustomersTypes } from 'features/account';

export enum OfferImageLayoutEnum {
  NoImage,
  BigTopRight,
  BigTopLeftRight,
  BigTop,
  SmallTop,
  BiggerTop,
}

export enum OfferImagePositionEnum {
  Top,
  Right,
  Left,
  Bottom,
  MobileTop,
  MobileBottom,
}

export enum OfferConclusionPageTypeEnum {
  Default,
  ExternalPage,
  UpsellPage,
}

export interface OfferPaymentImage {
  uuid: string;
  imageUrl: string;
  position: OfferImagePositionEnum;
}

export interface PaymentValuesItem {
  totalValue: number;
  installmentValue: number;
  installments: number;
}

export interface BuyCaptcha {
  captchaBase64: string;
  captchaUuid: string;
}

export interface BuyInformation {
  offerUuid: string;
  offerName: string;
  offerDescription: string;
  freeOffer: boolean;
  creditCardValues: PaymentValuesItem[];
  boletoValues: PaymentValuesItem[];
  pixValues: PaymentValuesItem[];
  interestRate: number;
  warrantyDays: number;
  withBirthDate: boolean;
  withAddress: boolean;
  offerImageLayout: OfferImageLayoutEnum;
  offerImages: OfferPaymentImage[];
  backgroundColor: string;

  offerConclusionPageType: OfferConclusionPageTypeEnum;
  offerExernalUrlBoleto: string;
  offerExternalUrlCreditCard: string;
  offerExternalUrlPix: string;

  creditCardInformation: string;
  isRecurrence: boolean;

  withTaxId: boolean;
  withEMailConfirmation: boolean;
  withPhone: boolean;

  disableCaptcha: boolean;
}

export type PaymentsMethod = 'creditCard' | 'boleto' | 'pix' | 'free';
export type PaymentSteps = 'loading' | 'contact' | 'payment' | 'success';

export interface CheckoutState {
  leadUuid: string;
  paymentStep: PaymentSteps;
  isStudent: boolean;
  bypassLogin: boolean;
  customerUuid: string;
  customerType: CustomersTypes;
  customerName: string;
  customerContactEmail: string;
  customerContactEmailConfirm: string;
  customerBirthOrFoundation: string;
  customerTaxId: string;
  customerContactPhone: string;
  internationalContactPhone: boolean;
  customerAddressLine1: string;
  customerAddressNumber: string;
  customerAddressLine2: string;
  customerNeighborhood: string;
  customerZipCode: string;
  customerCity: string;
  customerState: string;
  customerCountry: string;
  value: number;
  spotValue: number;
  paymentMethod: PaymentsMethod;
  installments: number;
  creditCardHolderName: string;
  creditCardExpirationMonth: number;
  creditCardExpirationYear: number;
  creditCardNumber: string;
  creditCardSecurityCode: string;
  sendLead: boolean;
  withBirthDate: boolean;
  withAddress: boolean;
  withTaxId: boolean;
  withEMailConfirmation: boolean;
  withPhone: boolean;
  disableCaptcha: boolean;
}

export interface PaymentsLeadApiResult {
  apiResultData: {
    uuid: string;
    isStudent: boolean;
    withPreviousEnrollments: boolean;
    points: number;
  };
  apiResultCode: number;
  apiResultMessage: string;
}

export interface PaymentsResponse {
  transactionUuid: string;
  transactionLocator: string;
  forIdentifiedStudent: true;
  value: number;
  netValue: number;

  boletoLinks?: {
    barcode: string;
    boletoUrl: string;
    expectedOn: string;
  }[];

  pixCode?: string;
  pixQrCode?: string;
}

export interface PaymentsApiResult {
  apiResultData: PaymentsResponse;
  apiResultCode: number;
  apiResultMessage: string;
}

export interface ActiveCampaingIdsState {
  addContactToList: number;
  addContactToListOnSuccess: number;
  addTagOnSuccessCreditCard: number;
  addTagOnSuccessBoleto: number;
  addTagOnSuccessPix: number;
}

export interface PaymentsState {
  buyInformation: BuyInformation;
  paymentsResponse: PaymentsResponse;
  activeCampaingIds: Partial<ActiveCampaingIdsState>;
  checkout: CheckoutState;
  showLogin: boolean;
  showLoginMessage: boolean;
  bypassLogin: boolean;
  hasAccount: boolean;
  captcha: BuyCaptcha;
}

export interface BuyInformationResponse extends BuyInformation {}

export type LayoutSize =
  | {
      width: number | string;
      height: number | string;
    }
  | false;

export interface LayoutItem {
  imageLayout: OfferImageLayoutEnum;
  top: LayoutSize;
  left: LayoutSize;
  right: LayoutSize;
  bottom: LayoutSize;
}
